<!-- 套餐审核 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-select v-model="auditStatus" placeholder="选择状态" @change="onSearch" clearable class="s_input">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input class="s_input" v-model="projectName" suffix-icon="el-icon-search" placeholder="搜索套餐名称" clearable @change="onSearch"></el-input>
      <el-button type="primary" @click="onAll" :disabled="multipleSelection.length == 0">一键审核</el-button>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :selectable="checkSelectable">
        </el-table-column>
        <el-table-column label="序号" show-overflow-tooltip width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" show-overflow-tooltip prop="packageType" label="项目类型">
          <template slot-scope="scope">
            {{ scope.row.packageType == 0 ? "项目套餐" :'' }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" show-overflow-tooltip prop="packageName" label="套餐名称"></el-table-column>
        <el-table-column min-width="140" show-overflow-tooltip prop="number" label="项目数量"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="discountPrice" label="套餐价（元）"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="originalPrice" label="原价（元）"> </el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="申请时间"></el-table-column>
        <el-table-column min-width="110" show-overflow-tooltip prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            <span :style="scope.row.auditStatus == 0 ? 'color:red' : ''">{{ scope.row.auditStatus == 0 ? "待审核" : scope.row.auditStatus == 1 ? "审核通过" :"审核不通过" }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="230px" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleDetail(scope.row)" v-if="scope.row.auditStatus != 0">查看</el-button>
            <el-button type="primary" plain @click="handlePass(scope.row)" v-if="scope.row.auditStatus == 0">通过</el-button>
            <el-button type="danger" plain @click="handleNoPass(scope.row)" v-if="scope.row.auditStatus == 0">不通过</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog title="审核不通过" :visible.sync="dialogVisible" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="ruleForm">
        <el-form-item label="审核不通过原因" prop="auditMark">
          <el-input type="textarea" placeholder="请输入" :autosize="{ minRows: 5, maxRows: 10 }" v-model="ruleForm.auditMark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量 -->
    <el-dialog title="一键审核" :visible.sync="dialogAll" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="ruleForm">
        <span style="margin-right: 20px;">请选择</span> <el-radio v-model="radio" label="1">审核通过</el-radio>
        <el-radio v-model="radio" label="2">审核不通过</el-radio>
        <el-form-item label="审核不通过原因" prop="auditMark" v-if="radio == 2" style="margin-top: 30px;">
          <el-input type="textarea" placeholder="请输入" :autosize="{ minRows: 5, maxRows: 10 }" v-model="ruleForm.auditMark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitFormAll('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          value: "0",
          label: "待审核",
        },
        {
          value: "1",
          label: "审核通过",
        },
        {
          value: "2",
          label: "审核不通过",
        },

      ],
      arry: [
        {
          value: "1",
          label: "体验项目",
        },
        {
          value: "2",
          label: "正式项目",
        },


      ],
      optionArry: [],
      auditStatus: "",
      arryStatus: '',
      dialogVisible: false,
      dialogAll: false,
      value: '',
      radio: '1',
      ruleForm: {
        auditMark: null, //内容
      },
      rules: {
        auditMark: [{ required: true, message: "缺少审核不通过原因", trigger: "blur" }],
      },
      tableData: [
        { index: 1 },
        { index: 2 }
      ], //表格数据
      multipleSelection: [],//选中表格数据
      datetime: [], //时间
      applyNum: "", //编号
      projectName: "", //
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectEnterpriseInfoList()

  },

  methods: {

    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.multipleSelection = val.map(item => item.id)
    },
    // 判断是否待审核才可选中
    checkSelectable(row, index) {
      return row.auditStatus == 0;
    },
    onAll() {
      this.dialogAll = true
    },
    submitFormAll(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.radio == '2') {
            this.ruleForm.idList = this.multipleSelection
            this.ruleForm.auditStatus = this.radio
            this.ruleForm.auditMark = this.ruleForm.auditMark || null
          } else {
            this.ruleForm.idList = this.multipleSelection
            this.ruleForm.auditStatus = this.radio
          }
          this.$axios.post(this.$api.auditProjectPackage, this.ruleForm).then(res => {
            this.selectEnterpriseInfoList()
            this.onCancel()
            this.$message({
              message: res.desc,
              type: "success",
            })
          })
            .catch(err => {
              this.$message({
                message: err.desc,
                type: "error",
              })
            })
        }
      })
    },
    // 获取列表
    selectEnterpriseInfoList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        auditStatus: this.auditStatus || null,
        packageName: this.projectName || null,//套餐名称
      }
      this.$axios.post(this.$api.selectProjectPackageList, params)
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },

    handleNoPass(row) {
      this.dialogVisible = true
      this.ruleForm.auditStatus = 2
      this.ruleForm.projectIdList = [row.id]
    },
    submitForm(ruleForm) {
      // console.log(this.ruleForm)
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$axios.post(this.$api.auditProjectPackage, this.ruleForm)
            .then(res => {
              this.selectEnterpriseInfoList()
              this.onCancel()
              this.$message({
                message: res.desc,
                type: "success",
              })
            })
            .catch(err => {
              this.$message({
                message: err.desc,
                type: "error",
              })
            })
        }
      })
    },
    onCancel() {
      this.dialogVisible = false
      this.dialogAll = false
      this.ruleForm = {}
    },
    // 通过
    handlePass(row) {
      this.$confirm("是否确认审核通过？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios.post(this.$api.auditProjectPackage, {
            // auditMark: this.ruleForm.auditMark,
            auditStatus: 1,
            projectIdList: [row.id],
          }).then(res => {
            this.$message({
              type: "success",
              message: res.desc,
            })
            this.selectEnterpriseInfoList()
          })
            .catch(error => {
              this.$message({
                type: "error",
                message: error.desc,
              })
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核",
          })
        })
    },

    onSearch() {
      this.clearData()
      this.selectEnterpriseInfoList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },

    // 查看
    handleDetail(row) {
      this.$router.push({
        path: "/formalProject/examine/detail/setMenuInfo",
        query: {
          id: row.id,
        },
      })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectEnterpriseInfoList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectEnterpriseInfoList()
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  .el_upload__tip {
    text-align: center;
    margin-bottom: 20px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 16px;
  }

  .el-textarea {
    width: 88%;
  }

  ::v-deep .el-input__count {
    background: transparent !important;
  }

  ::v-deep .el-dialog .el-dialog__header {
    padding: 11px 20px !important;
  }

  ::v-deep .el-dialog .el-input__inner {
    width: 240px !important;
  }
}
</style>
